// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"fe7314bf","316":"3a416a29","520":"1713f7c1","566":"dc6406d4","578":"a27bdfc9","938":"025fc810"}[chunkId] + ".chunk.js";
};